// src/components/shared/Stepper.js
import React from 'react';
import styled from 'styled-components';

const StepperContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

const Step = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${(props) => (props.active ? props.theme.colors.primary : props.theme.colors.inputGray)};
  padding: ${(props) => props.theme.spacing(1)} ${(props) => props.theme.spacing(2)};
  border-bottom: 2px solid ${(props) => (props.active ? props.theme.colors.primary : 'transparent')};
  cursor: pointer;
  transition: color 0.3s, border-color 0.3s;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    border-color: ${(props) => props.theme.colors.primary};
  }

  &:not(:last-child)::after {
    content: '>';
    margin: 0 8px;
  }
`;

const Stepper = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, index) => `Step ${index + 1}`);

  return (
    <StepperContainer>
      {steps.map((step, index) => (
        <Step key={index} active={index + 1 === currentStep}>
          {step}
        </Step>
      ))}
    </StepperContainer>
  );
};

export default Stepper;
